import { z } from "zod";
import { DefaultValues, FieldValues, useForm } from "react-hook-form";
import { zodResolver } from "@hookform/resolvers/zod";

type SchemaType<T> = z.Schema<T>;

export const useValidateForm = <T extends FieldValues>(
  schema: SchemaType<T>,
  defaultValues?: DefaultValues<T>,
) => {
  const {
    register,
    control,
    handleSubmit,
    formState: { errors },
    reset,
    getValues,
    setValue,
  } = useForm<T>({
    resolver: zodResolver(schema),
    defaultValues,
  });

  return {
    register,
    control,
    handleSubmit,
    errors,
    reset,
    getValues,
    setValue,
  };
};
